import { createReducer, on } from '@ngrx/store';
import {
  ConfirmationPageActions,
  TransactionsTableActions,
} from '../../create-request/actions';
import { ComponentState } from '../../shared/types/ComponentState';
import { AccountInfoActions } from '../actions';
import { StandingAuthConfirmationPageActions } from '../../standing-authorizations/actions';

export const headerStateKey = 'headerState';

export interface State extends ComponentState {
  serviceError: boolean
}

export const initialHeaderState: State = {
  loading: false,
  error: '',
  hasError: false,
  serviceError: false
};

export const reducer = createReducer(
  initialHeaderState,
  on(
    AccountInfoActions.updateSubAccount,
    ConfirmationPageActions.createAnotherRequestClicked,
    ConfirmationPageActions.viewTransactionStatusClicked,
    StandingAuthConfirmationPageActions.createNewStandingAuthClicked,
    StandingAuthConfirmationPageActions.returnStandingAuthClicked,
    AccountInfoActions.refresh,
    (state, { accountId }) => {
      return {
        ...state,
        loading: true,
      };
    }
  ),
  on(AccountInfoActions.loadAccountInfoSuccess, AccountInfoActions.loadPalAccountInfoSuccess, (state) => {
    return {
      ...state,
      loading: false,
      serviceError: false
    };
  }),
  on(AccountInfoActions.loadAccountInfoFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.errorMsg,
      serviceError: false
    };
  }),
  on(AccountInfoActions.loadAccountInfoServiceFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.errorMsg,
      serviceError: true
    };
  })
);
